import { FC, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import { Box, Loader } from '@qwealth/qcore';

import { useAppDispatch, useAppSelector } from 'data/store';
import { selectClientComplianceReview } from 'data/selectors/compliance';
import CognitoWrappedClientQVault from 'components/common/CognitoWrappedClientQVault';
import { useSelector } from 'react-redux';
import { selectPartners } from '@qwealth/qdata';
import { QVaultFolder } from 'data/models/QVault';
import { getQVaultDefaultFoldersForPartner } from 'data/data-layer/qvault';
import { errorHandler } from 'services/axiosService';
import { ClientComplianceReview } from 'data/models/Compliance';

type qvaultOption = {
  name: string;
  qid: string;
};

const ComplianceQVault: FC = (): JSX.Element => {
  const selectedClient: ClientComplianceReview | undefined = useAppSelector(selectClientComplianceReview);
  const selectedHousehold = selectedClient?.household;
  const [isAdvisor, setIsAdvisor] = useState<boolean>(true);
  const [qVaultOptions, setQVaultOptions] = useState<qvaultOption[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);
  const partners = useSelector(selectPartners);
  const [defaultFolders, setDefaultFolders] = useState<QVaultFolder[]>([]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const householdPartner = partners.find(partner => partner.partnerName === selectedHousehold?.partnerName);
    if (householdPartner !== undefined && householdPartner.id !== undefined) {
      (async () => {
        setIsloading(true);
        try {
          const partnerFolders = await getQVaultDefaultFoldersForPartner(householdPartner.id as number);
          setDefaultFolders(partnerFolders);
        } catch (error) {
          await errorHandler(dispatch, 'Failed to get default folders')(error);
        }
        setIsloading(false);
      })();
    }
  }, [partners, selectedHousehold]);

  useEffect(() => {
    const membersOptions: qvaultOption[] = [];

    if (selectedHousehold) {
      membersOptions.push({
        name: selectedHousehold.name ?? '',
        qid: selectedHousehold.QID ?? '',
      });
    }

    if (selectedClient) {
      membersOptions.push({
        name: selectedClient.name ?? '',
        qid: selectedClient.QID ?? '',
      });
    }

    setQVaultOptions(membersOptions);
  }, [selectedClient, selectedHousehold]);

  return (
    <Box width="100%" overflowY="scroll" display="flex" flexDirection="column" gap="default">
      <Box display="flex" flexDirection="row" alignItems="center" gap="large">
        Client View
        <Form.Check
          id="isAdvisor"
          type="switch"
          checked={!isAdvisor}
          onChange={() => {
            setIsAdvisor(prevState => !prevState);
          }}
        />
      </Box>

      {isLoading ? (
        <Loader />
      ) : (
        <CognitoWrappedClientQVault
          qid={selectedHousehold?.QID ?? ''}
          name={selectedHousehold?.name ?? ''}
          isAdvisor={isAdvisor}
          members={qVaultOptions}
          defaultFolders={defaultFolders}
        />
      )}
    </Box>
  );
};

export default ComplianceQVault;
